import { ROUTES } from '@/constants/routes'

export default function isNotReviewsTrialEnded({ next, router, store }) {
    const { account, getWorkspaceSlug } = store

    if (account && account.is_active) {
        return router.push({ name: ROUTES.reporting, params: { workspace: getWorkspaceSlug } })
    }

    next()
}
